import { useEffect, useState } from 'react';
import { NavLink, Link, useNavigate } from "react-router-dom";
import { FormControl, Nav, Modal, Row, Col, Dropdown, Badge, Navbar, InputGroup } from 'react-bootstrap';
import logo from '../assets/images/logo.png';
import Alert from 'react-bootstrap/Alert';
import { FaExchangeAlt } from "react-icons/fa";
import { getOrgProfile } from '../apiservices/ApiServices';
import Loader from '../components/Loader/Loader';

const SideMenuIcon = () => {
    document.querySelector(".app")?.classList.toggle("sidenav-toggled");
}

const DarkMode = () => {

    if (document.querySelector("body")?.classList.contains('dark-mode')) {
        document.querySelector("body")?.classList.remove('dark-mode');

        localStorage.setItem("sashlightmode", "true");
        localStorage.removeItem("sashdarktheme");

        // let myonoffswitch2 = document.querySelector("#myonoffswitch1");
        // myonoffswitch2.checked = true;
        // let myonoffswitch5 = document.querySelector("#myonoffswitch3");
        // myonoffswitch5.checked = true;
        // let myonoffswitch8 = document.querySelector("#myonoffswitch6");
        // myonoffswitch8.checked = true;
    }
    else {
        document.querySelector("body")?.classList.add('dark-mode');
        localStorage.setItem("sashdarktheme", "true");
        localStorage.removeItem("sashlightmode");
        // let myonoffswitch2 = document.querySelector("#myonoffswitch2");
        // myonoffswitch2.checked = true;
        // let myonoffswitch5 = document.querySelector("#myonoffswitch5");
        // myonoffswitch5.checked = true;
        // let myonoffswitch8 = document.querySelector("#myonoffswitch8");
        // myonoffswitch8.checked = true;
    }
};

// FullScreen
var elem = document.documentElement;
var i = true;

const Fullscreen = (vale) => {
    switch (vale) {
        case true:
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.webkitRequestFullscreen) { /* Safari */
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) { /* IE11 */
                elem.msRequestFullscreen();
            }
            i = false
            break;
        case false:
            document.exitFullscreen()
            i = true
            break;
    }
}

const SidSwitcherIcon = () => {
    console.log("working");
    document.querySelector(".demo_changer")?.classList.toggle("active");
    let Rightside = document.querySelector(".demo_changer")
    Rightside.style.insetInlineEnd = "0px";

}

const RightSideBar = () => {
    document.querySelector(".sidebar-right")?.classList.toggle("sidebar-open");
}

const Header = () => {
    const [show, setShow] = useState(false);
    const [show1, setShow1] = useState(false);
    const [show2, setShow2] = useState(false);
    const [isShowProfile, setIsShowProfile] = useState(false);
    const [InputValue, setInputValue] = useState("");
    const [searchval, setsearchval] = useState("Type something");
    const [searchcolor, setsearchcolor] = useState("text-dark");
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [isLoadings, setLoadings] = useState(false);
    const [profile, setProfile] = useState([]);
    const [userData, setUserData] = useState([]);
    const [profileData, setProfileData] = useState([]);

    const [mastersOpen, setMastersOpen] = useState(false);
    const [organizationOpen, setOrganizationOpen] = useState(false);

    const navigate = useNavigate();

    const getOrgProfiles = async () => {
        setLoadings(true);
        try {
            const res = await getOrgProfile();
            setProfileData(res.data?.data);
            setIsShowProfile(true);
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            console.log(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        const profileData = localStorage.getItem('defaultProfile');
        if (profileData) {
            setProfile(JSON.parse(profileData));
        }

        const userDatas = localStorage.getItem('userData');
        if (userDatas) {
            setUserData(JSON.parse(userDatas));
        }
    }, []);

    const toggleMasters = () => {
        setMastersOpen(!mastersOpen);
    };

    const toggleOrganization = () => {
        setOrganizationOpen(!organizationOpen);
    };


    function logOut() {
        setShow(false);
        localStorage.removeItem('useToken');
        localStorage.removeItem('userData');
        localStorage.removeItem('defaultProfile');
        localStorage.removeItem('profileId');

        navigate("/");
        window.location.reload(true);
    }

    const hendelToggleProfile = () => {
        if (isShowProfile) {
            setIsShowProfile(!isShowProfile);
        }
        else {
            getOrgProfiles();
        }
    };

    const hendelChangeProfile = (item) => {
        localStorage.setItem('defaultProfile', JSON.stringify(item));
        localStorage.setItem('profileId', item?.profile_id);
        setProfile(item);
        setIsShowProfile(false);
    };

    return (
        <>
            <div className=''>
                <div className='header sticky app-header header1'>
                    <div className='container-fluid main-container'>
                        <div className='d-flex'>
                            <Link aria-label="Hide Sidebar" className="app-sidebar__toggle" data-bs-toggle="sidebar" to="#" onClick={() => SideMenuIcon()} />
                            <Link className="logo-horizontal " to={`${import.meta.env.BASE_URL}Dashboard`}>
                                <img src={logo} className="logoimg header-brand-img desktop-logo" alt="logo" />
                                <img src={logo} className="logoimg header-brand-img light-logo1" alt="logo" />
                            </Link>
                            {/* <div className='serachbox main-header-center ms-3 d-none d-lg-block'>
                                <input placeholder="Search for results..." type="search" className="form-control" />
                                <button className="serachbtns btn px-0 pt-2">
                                    <i className="fe fe-search" aria-hidden="false"></i>
                                </button>
                            </div> */}
                            <Navbar className="rightnavpanel d-flex order-lg-2 ms-auto header-right-icons px-0" expand="lg">
                                <Dropdown className="dropdown d-none">
                                    <Link to="#" className="nav-link icon " >
                                        <i className="fe fe-search"></i>
                                    </Link>
                                    <Dropdown.Menu className="header-search dropdown-menu-start ">
                                        <InputGroup className="input-group w-100 p-2">
                                            <FormControl type="text" placeholder="Search...." />
                                            <InputGroup.Text className="btn btn-primary">
                                                <i className="fe fe-search" aria-hidden="true"></i>
                                            </InputGroup.Text>
                                        </InputGroup>
                                    </Dropdown.Menu>
                                </Dropdown>
                                <Navbar.Toggle aria-controls="basic-navbar-nav" className="navbar-toggler navresponsive-toggler d-lg-none ms-auto"
                                >
                                    <i className="navbar-toggler-icon fe fe-more-vertical"></i>
                                </Navbar.Toggle>
                                <div className="responsive-navbar p-0">
                                    <Navbar.Collapse className="px-0" id="navbarSupportedContent-4">
                                        <div className="d-flex order-lg-2">
                                            <Dropdown className="d-lg-none d-flex" >
                                                <Dropdown.Toggle href="#" className="nav-link icon no-caret" variant="">
                                                    <i className="fe fe-search"></i>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu className="header-search dropdown-menu-start">
                                                    <InputGroup className="w-100 p-2">
                                                        <FormControl type="text" placeholder="Search...." />
                                                        <InputGroup.Text>
                                                            <i className="fa fa-search" aria-hidden="true" ></i>
                                                        </InputGroup.Text>
                                                    </InputGroup>
                                                </Dropdown.Menu>
                                            </Dropdown>

                                            {/* Country Select Modal */}


                                            {/* Dark Mode */}

                                            <div className="dropdown  d-flex">
                                                <Nav.Link className="nav-link icon theme-layout nav-link-bg layout-setting" onClick={() => DarkMode()}>
                                                    <span className="dark-layout"><i className="fe fe-moon"></i></span>
                                                    <span className="light-layout"><i className="fe fe-sun"></i></span>
                                                </Nav.Link>
                                            </div>


                                            {/* FullScreen button */}

                                            <div className="dropdown d-flex">
                                                <Nav.Link className="nav-link icon full-screen-link nav-link-bg" onClick={() => Fullscreen(i)}>
                                                    <i className="fe fe-minimize fullscreen-button"></i>
                                                </Nav.Link>
                                            </div>

                                            {/* Notification */}

                                            <Dropdown className="d-flex notifications">
                                                <Dropdown.Toggle variant='' className="nav-link icon no-caret"><i className="fe fe-bell"></i><span className=" pulse"></span></Dropdown.Toggle>
                                                <Dropdown.Menu className="dropdown-menu-end dropdown-menu-arrow">
                                                    <div className="drop-heading border-bottom">
                                                        <div className="d-flex">
                                                            <h6 className="mt-1 mb-0 fs-16 fw-semibold text-dark">Notifications
                                                            </h6>
                                                        </div>
                                                    </div>
                                                    <div className="notifications-menu">
                                                        <Dropdown.Item className=" d-flex" href={`${import.meta.env.BASE_URL}pages/notificationlist/`}>
                                                            <div
                                                                className="me-3 notifyimg  bg-primary brround box-shadow-primary">
                                                                <i className="fe fe-mail"></i>
                                                            </div>
                                                            <div className="mt-1">
                                                                <h5 className="notification-label mb-1">New Application received
                                                                </h5>
                                                                <span className="notification-subtext">3 days ago</span>
                                                            </div>
                                                        </Dropdown.Item>
                                                        <Dropdown.Item className="d-flex" href={`${import.meta.env.BASE_URL}pages/notificationlist/`}>
                                                            <div
                                                                className="me-3 notifyimg  bg-secondary brround box-shadow-secondary">
                                                                <i className="fe fe-check-circle"></i>
                                                            </div>
                                                            <div className="mt-1">
                                                                <h5 className="notification-label mb-1">Project has been
                                                                    approved</h5>
                                                                <span className="notification-subtext">2 hours ago</span>
                                                            </div>
                                                        </Dropdown.Item>
                                                        <Dropdown.Item className="d-flex" href={`${import.meta.env.BASE_URL}pages/notificationlist/`}>
                                                            <div
                                                                className="me-3 notifyimg  bg-success brround box-shadow-success">
                                                                <i className="fe fe-shopping-cart"></i>
                                                            </div>
                                                            <div className="mt-1">
                                                                <h5 className="notification-label mb-1">Your Product Delivered
                                                                </h5>
                                                                <span className="notification-subtext">30 min ago</span>
                                                            </div>
                                                        </Dropdown.Item>
                                                        <Dropdown.Item className="d-flex" href={`${import.meta.env.BASE_URL}pages/notificationlist/`}>
                                                            <div className="me-3 notifyimg bg-pink brround box-shadow-pink">
                                                                <i className="fe fe-user-plus"></i>
                                                            </div>
                                                            <div className="mt-1">
                                                                <h5 className="notification-label mb-1">Friend Requests</h5>
                                                                <span className="notification-subtext">1 day ago</span>
                                                            </div>
                                                        </Dropdown.Item>
                                                    </div>
                                                    <div className="dropdown-divider m-0"></div>
                                                    <Dropdown.Item href={`${import.meta.env.BASE_URL}pages/notificationlist/`}
                                                        className="dropdown-item text-center p-3 text-muted">View all
                                                        Notification</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>


                                            {/* Profile  */}
                                            <Dropdown className="d-flex profile-1">
                                                <Dropdown.Toggle variant='' className="nav-link leading-none d-flex no-caret">
                                                    <img alt="profile-user" className="avatar  profile-user brround cover-image" />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu className="dropdown-menu-end dropdown-menu-arrow">
                                                    <div className='usercard'>
                                                        <div className='userinfo-box'>
                                                            <div className='userio'>
                                                                <img alt="profile-user" className="avatar  profile-user brround cover-image" />
                                                            </div>
                                                            <div className='usercontent'>
                                                                <h5 className="fw-semibold">{userData?.first_name} {userData?.last_name}</h5>
                                                                <small className="text-muted">{profile?.profile_name} {profile?.entity_type != '' && profile?.entity_type}</small>
                                                            </div>
                                                        </div>
                                                        <button className='togglepro' onClick={() => hendelToggleProfile()}><FaExchangeAlt /></button>
                                                    </div>
                                                    <div className="dropdown-divider m-0"></div>
                                                    {isShowProfile && (
                                                        <div className='profileLists'>

                                                            {profileData?.map((item) => (
                                                                <div key={`proids_${item?.profile_id}`} className='profilelist-box' onClick={() => hendelChangeProfile(item)}>
                                                                    <div className='profileImg'>
                                                                        <img alt="profile-user" className="avatar  profile-user brround cover-image" />
                                                                    </div>
                                                                    <div className='usercontent'>
                                                                        <h5 className="fw-semibold">{item?.profile_name}</h5>
                                                                        <small className="text-muted">{item?.entity_type}</small>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                    {/* <Dropdown.Item href={`${import.meta.env.BASE_URL}pages/profile/`}>
                                                        <i className="dropdown-icon fe fe-user"></i> Profile
                                                    </Dropdown.Item> */}
                                                    <Dropdown.Item onClick={() => setShow(true)}>
                                                        <i className="dropdown-icon fe fe-alert-circle"></i> Sign out
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </Navbar.Collapse>
                                </div>
                            </Navbar>
                        </div>
                    </div>
                </div>
            </div>

            <div className='sticky'>
                <div className='app-sidebar'>
                    <div className='scrollbar-container ps ps--active-y ps--scrolling-y'>
                        <div className="side-header">
                            <Link className="header-brand1" to={`${import.meta.env.BASE_URL}dashboard/`}>
                                <img src={logo} className="logoimg header-brand-img desktop-logo" alt="logo1" />
                                <img src={logo} className="logoimg header-brand-img toggle-logo" alt="logo-2" />
                                <img src={logo} className="logoimg header-brand-img light-logo" alt="logo-3" />
                                <img src={logo} className="logoimg header-brand-img light-logo1" alt="logo-4" />
                            </Link>
                        </div>

                        <div className="main-sidemenu">
                            <ul className="side-menu" style={{ marginLeft: "0px" }}>
                                {/* <li className="slide is-expanded">
                                    <NavLink className="side-menu__item" to="/">
                                        <div className='side-menu__icon'>
                                            <i className="fe fe-home"></i>
                                        </div>
                                        <span className="side-menu__label">Dashboard</span>
                                    </NavLink>
                                </li> */}

                                <li className="slide is-expanded">
                                    <Link to="#" className="side-menu__item" onClick={toggleOrganization}>
                                        <div className='side-menu__icon'>
                                            <i className="fe fe-slack"></i>
                                        </div>
                                        <span className="side-menu__label">Organization</span>
                                        <i className={`sub-angle fa ${organizationOpen ? 'fa-angle-down' : 'fa-angle-right'}`}></i>
                                    </Link>
                                    <ul
                                        className="slide-menu"
                                        style={{ display: organizationOpen ? "block" : "none" }}
                                    >
                                        <div className=''>
                                            <li className="sub-slide">
                                                <NavLink className="sub-slide-item" to="Organization">
                                                    Organization
                                                </NavLink>
                                            </li>
                                            <li className="sub-slide">
                                                <NavLink className="sub-slide-item" to="/org-module/associate-partner">
                                                    Assoicate Partner
                                                </NavLink>
                                            </li>
                                            <li className="sub-slide">
                                                <NavLink className="sub-slide-item" to="/org-module/billing-entity">
                                                    Billing Entity
                                                </NavLink>
                                            </li>
                                            <li className="sub-slide">
                                                <NavLink className="sub-slide-item" to="/org-module/channel-partner">
                                                    Channel Partner
                                                </NavLink>
                                            </li>
                                            <li className="sub-slide">
                                                <NavLink className="sub-slide-item" to="/org-module/client">
                                                    Client
                                                </NavLink>
                                            </li>

                                            <li className="sub-slide">
                                                <NavLink className="sub-slide-item" to="/org-module/vendors-partner">
                                                    Vendors
                                                </NavLink>
                                            </li>
                                        </div>
                                    </ul>
                                </li>

                                <li className="slide is-expanded">
                                    <NavLink className="side-menu__item" to="/channel-partners">
                                        <div className='side-menu__icon'>
                                            <i className="fa fa-handshake-o"></i>
                                        </div>
                                        <span className="side-menu__label">Channel Partners</span>
                                    </NavLink>
                                </li>

                                <li className="slide is-expanded">
                                    <NavLink className="side-menu__item" to="/employee">
                                        <div className='side-menu__icon'>
                                            <i className="fa fa-user"></i>
                                        </div>
                                        <span className="side-menu__label">Employee</span>
                                    </NavLink>
                                </li>

                                <li className="slide is-expanded">
                                    <NavLink className="side-menu__item" to="/leads">
                                        <div className='side-menu__icon'>
                                            <i className="mdi mdi-account-card-details"></i>
                                        </div>
                                        <span className="side-menu__label">Leads</span>
                                    </NavLink>
                                </li>

                                {/* <li className="slide">
                                    <NavLink className="side-menu__item" to="/quotation">
                                        <div className='side-menu__icon'>
                                            <i className="fa fa-file-code-o"></i>
                                        </div>
                                        <span className="side-menu__label">Quotations</span>
                                    </NavLink>
                                </li> */}

                                {/* <li className="slide">
                                    <NavLink className="side-menu__item" to="/communicatin-log">
                                        <div className='side-menu__icon'>
                                            <i className="fa fa-file-audio-o"></i>
                                        </div>
                                        <span className="side-menu__label">Communicatin Log</span>
                                    </NavLink>
                                </li> */}

                                <li className="slide">
                                    <NavLink className="side-menu__item" to="/projects">
                                        <div className='side-menu__icon'>
                                            <i className="fa fa-tags"></i>
                                        </div>
                                        <span className="side-menu__label">Projects</span>
                                    </NavLink>
                                </li>


                                <li className="slide">
                                    <NavLink className="side-menu__item" to="/invoices">
                                        <div className='side-menu__icon'>
                                            <i className="fa fa-newspaper-o"></i>
                                        </div>
                                        <span className="side-menu__label">Invoices</span>
                                    </NavLink>
                                </li>

                                <li className="slide">
                                    <NavLink className="side-menu__item" to="/mail-templates">
                                        <div className='side-menu__icon'>
                                            <i className="fa fa-id-card"></i>
                                        </div>
                                        <span className="side-menu__label">Mail Template</span>
                                    </NavLink>
                                </li>

                                <li className="slide">
                                    <NavLink className="side-menu__item" to="/payment-due">
                                        <div className='side-menu__icon'>
                                            <i className="fa fa-id-card"></i>
                                        </div>
                                        <span className="side-menu__label">Payment Due</span>
                                    </NavLink>
                                </li>

                                <li className="slide is-expanded">
                                    <Link to="#" className="side-menu__item" onClick={toggleMasters}>
                                        <div className='side-menu__icon'>
                                            <i className="fa fa-list-ol"></i>
                                        </div>
                                        <span className="side-menu__label">Masters</span>
                                        <i className={`sub-angle fa ${mastersOpen ? 'fa-angle-down' : 'fa-angle-right'}`}></i>
                                    </Link>
                                    <ul
                                        className="slide-menu"
                                        style={{ display: mastersOpen ? "block" : "none" }}
                                    >
                                        <div className=''>
                                            <li className="sub-slide">
                                                <NavLink className="sub-slide-item" to="/master">
                                                    <span className="side-menu__label">Master Type</span>
                                                </NavLink>
                                            </li>
                                            <li className="sub-slide">
                                                <NavLink className="sub-slide-item" to="/master/subMaster/1">
                                                    <span className="side-menu__label">Comman Master</span>
                                                </NavLink>
                                            </li>


                                            <li className="sub-slide">
                                                <NavLink className="sub-slide-item" to="/masters/activity">
                                                    Activity
                                                </NavLink>
                                            </li>
                                            <li className="sub-slide">
                                                <NavLink className="sub-slide-item" to="/masters/activity-template">
                                                    Activity Template
                                                </NavLink>
                                            </li>
                                            <li className="sub-slide">
                                                <NavLink className="sub-slide-item" to="/masters/communication-type">
                                                    Communication Type
                                                </NavLink>
                                            </li>
                                            <li className="sub-slide">
                                                <NavLink className="sub-slide-item" to="/masters/document-type">
                                                    Document Type
                                                </NavLink>
                                            </li>

                                            <li className="sub-slide">
                                                <NavLink className="sub-slide-item" to="/masters/functions">
                                                    Functions/Department
                                                </NavLink>
                                            </li>

                                            <li className="sub-slide">
                                                <NavLink className="sub-slide-item" to="/masters/organization-stage">
                                                    Organization Stage
                                                </NavLink>
                                            </li>

                                            <li className="sub-slide">
                                                <NavLink className="sub-slide-item" to="/masters/sectors">
                                                    Sectors
                                                </NavLink>
                                            </li>

                                            {/* <li className="sub-slide">
                                                <NavLink className="sub-slide-item" to="/masters/role">
                                                    Role
                                                </NavLink>
                                            </li> */}


                                            <li className="sub-slide">
                                                <NavLink className="sub-slide-item" to="masters/project-category">
                                                    Project Category
                                                </NavLink>
                                            </li>

                                            <li className="sub-slide">
                                                <NavLink className="sub-slide-item" to="/masters/product-category">
                                                    Product Category
                                                </NavLink>
                                            </li>
                                            <li className="sub-slide">
                                                <NavLink className="sub-slide-item" to="/masters/products">
                                                    Products
                                                </NavLink>
                                            </li>
                                        </div>
                                    </ul>
                                </li>
                            </ul>
                            <div className="slide-right" id="slide-right"><svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24"><path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path></svg></div>
                        </div>
                    </div>
                </div>
            </div>

            {show ? (<>
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Are you sure want to Logout?</Alert.Heading>
                    <hr />
                    <div className='button-boxs grid'>
                        <div>
                            <button onClick={() => logOut()} className='btn btn-primary'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShow(false)} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}

            <div className="jumps-prevent" style={{ paddingTop: '60px' }}></div>
            {isLoadings && <Loader />}
        </>
    )
}

export default Header